// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"ProjectStatusChangePopup_pageStyle__2omET","dialogCard":"ProjectStatusChangePopup_dialogCard__13br6"};